(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/numbergames-related/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/numbergames-related/assets/javascripts/prescript.js');

'use strict';

var _svs, _svs$numbergames_rela, _svs$numbergames_rela2, _svs$numbergames_rela3;
(_svs$numbergames_rela = (_svs = svs).numbergames_related) !== null && _svs$numbergames_rela !== void 0 ? _svs$numbergames_rela : _svs.numbergames_related = {};
(_svs$numbergames_rela3 = (_svs$numbergames_rela2 = svs.numbergames_related).logger) !== null && _svs$numbergames_rela3 !== void 0 ? _svs$numbergames_rela3 : _svs$numbergames_rela2.logger = new svs.core.log.Logger('module:numbergames_related');

 })(window);